import { render, staticRenderFns } from "./Tanto.vue?vue&type=template&id=c909070a&scoped=true&lang=pug&"
import script from "./Tanto.vue?vue&type=script&lang=coffee&"
export * from "./Tanto.vue?vue&type=script&lang=coffee&"
import style0 from "./Tanto.vue?vue&type=style&index=0&id=c909070a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c909070a",
  null
  
)

export default component.exports